import { Breakpoints, styled } from "@vw-marketing/us-components";

export const StyledFilterTransmissionContainer =  styled.div`
${() => `
    display: flex;
    flex-direction: column;
    .label-wrapper {
        margin-bottom: 17px;
    }
    @media (min-width: ${Breakpoints.b960}px) {
    }
`}`

export const StyledTransmissionCheckboxContainer =  styled.div`
${() => `
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    row-gap: 15px;
    margin-top: 20px;


    @media (min-width: ${Breakpoints.b960}px) {
        padding-right: 4px;
    }
`}`
